import { gql } from '@apollo/client';

export const mutation = gql`
  mutation InsertAnalyticsFileVersion($object: analytics_file_versions_insert_input!) {
    insert_analytics_file_versions_one(object: $object) {
      id
    }
  }
`;

export function buildVariables({ analyticsFileId, buildType, syncInjectorVersion, syncVersionRows }) {
  return {
    object: {
      analyticsFileId,
      buildType,
      syncInjectorVersion,
      analytics_file_sync_versions: { data: syncVersionRows },
    },
  };
}
